import { gql } from 'graphql-request'

const UPDATE_PUBLISHER_FEES = gql`
  mutation updatePublisher(
    $id: ID!
    $revenueShareMobile: Float
    $revenueBonusMobile: Float
    $revenueShareRiskBufferMobile: Float
    $revenueShareTransactionFeeMobile: Float
  ) {
    publisherUpdateFees(
      input: {
        id: $id
        attributes: {
          revenueShareMobile: $revenueShareMobile
          revenueBonusMobile: $revenueBonusMobile
          revenueShareRiskBufferMobile: $revenueShareRiskBufferMobile
          revenueShareTransactionFeeMobile: $revenueShareTransactionFeeMobile
        }
      }
    ) {
      publisherFees {
        revenueShareMobile
        revenueBonusMobile
        revenueShareRiskBufferMobile
        revenueShareTransactionFeeMobile
        revenueFeesHistory {
          dateSet
          revenueShareMobile
          revenueBonusMobile
          revenueShareRiskBufferMobile
          revenueShareTransactionFeeMobile
        }
        revenueFloorTurboApplications {
          id
          name
          revenueFloorTurboPlacements {
            id
            name
          }
        }
      }
      errors
    }
  }
`

export default UPDATE_PUBLISHER_FEES
